module.exports = __webpack_public_path__ + "img/pic_home_introduction.81565235.jpg";